import { serviceGo } from '@/utils/request'

export interface CommentUser {
  id: number
  nickname: string
  avatar: string
}

export interface AdminComment {
  id: number
  user: CommentUser
  game: { id: number; title: string }
  content: string
  ip_region: string
  like_count: number
  reply_count: number
  is_pinned: boolean
  is_featured: boolean
  status: number
  deleted_at: string | null
  created_at: string
  reply_to_user?: CommentUser
  parent_id?: number
  parent?: { id: number; content: string; user: CommentUser }
}

export interface PageResult<T> {
  items: T[]
  page: number
  page_size: number
  total: number
}

export interface ListCommentParams {
  game_id?: number
  user_id?: number
  keyword?: string
  status?: number
  pinned?: '1' | ''
  featured?: '1' | ''
  page: number
  page_size: number
}

export async function listComments(params: ListCommentParams): Promise<PageResult<AdminComment>> {
  const resp = await serviceGo.get('/api_v2/admin/comments', { params })
  return resp.data.data
}

export async function patchComment(
  id: number,
  patch: { is_pinned?: 0 | 1; is_featured?: 0 | 1; status?: 1 | 2 }
): Promise<void> {
  await serviceGo.patch(`/api_v2/admin/comments/${id}`, patch)
}

export async function deleteComment(id: number): Promise<void> {
  await serviceGo.delete(`/api_v2/admin/comments/${id}`)
}

export interface CommentReport {
  id: number
  comment: { id: number; content: string; user_id: number; status: number; deleted_at: string | null }
  reporter: CommentUser
  reason: string
  detail: string
  status: number
  handled_by: number | null
  created_at: string
  handled_at: string | null
}

export async function listReports(params: {
  status?: number
  page: number
  page_size: number
}): Promise<PageResult<CommentReport>> {
  const resp = await serviceGo.get('/api_v2/admin/comment-reports', { params })
  return resp.data.data
}

export async function handleReport(
  id: number,
  action: 'resolve' | 'dismiss',
  hide_comment = false
): Promise<void> {
  await serviceGo.patch(`/api_v2/admin/comment-reports/${id}`, { action, hide_comment })
}
